/**
 * Построчная разница двух текстов по наибольшей общей подпоследовательности.
 * Чистая функция без импортов: нужна вкладке «Шаблоны» (версия против текущей).
 */
export type DiffLine = { kind: "same" | "del" | "add"; text: string };

export function lineDiff(a: string, b: string): DiffLine[] {
  const x = a.split("\n");
  const y = b.split("\n");
  // lcs[i * w + j] — длина НОП суффиксов x[i..] и y[j..]
  const w = y.length + 1;
  const lcs = new Array<number>((x.length + 1) * w).fill(0);
  const at = (i: number, j: number) => lcs[i * w + j]!;
  for (let i = x.length - 1; i >= 0; i--)
    for (let j = y.length - 1; j >= 0; j--)
      lcs[i * w + j] = x[i] === y[j] ? at(i + 1, j + 1) + 1 : Math.max(at(i + 1, j), at(i, j + 1));
  const out: DiffLine[] = [];
  let i = 0;
  let j = 0;
  while (i < x.length && j < y.length) {
    if (x[i] === y[j]) {
      out.push({ kind: "same", text: x[i]! });
      i++;
      j++;
    } else if (at(i + 1, j) >= at(i, j + 1)) out.push({ kind: "del", text: x[i++]! });
    else out.push({ kind: "add", text: y[j++]! });
  }
  while (i < x.length) out.push({ kind: "del", text: x[i++]! });
  while (j < y.length) out.push({ kind: "add", text: y[j++]! });
  return out;
}
